import React from 'react';
import { Box, Button, Container, Group, Paper, Stack, Text, Title } from '@mantine/core';

type TErrorBoundaryProps = React.PropsWithChildren<{}>;

interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<TErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: TErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error(error, errorInfo.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box mih='100vh' display='flex' style={{ alignItems: 'center' }}>
          <Container size='sm' w='100%'>
            <Paper withBorder shadow='sm' radius='md' p='xl'>
              <Stack spacing='md' align='center' ta='center'>
                <Title order={2}>Something went wrong</Title>
                <Text c='dimmed' maw={440}>
                  We hit an unexpected issue while loading this page. Please try reloading and continue your order.
                </Text>
                <Group>
                  <Button onClick={this.handleReload} color='red' radius='md'>
                    Reload page
                  </Button>
                </Group>
              </Stack>
            </Paper>
          </Container>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
